import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Switch,
  Box,
  Paper,
  IconButton,
  Typography,
  Grid,
  useTheme,
} from '@mui/material';
import {
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  Close as CloseIcon,
  Shuffle as ShuffleIcon,
  FormatListNumbered as SequentialIcon,
  ErrorOutline as WrongFirstIcon,
  Assessment as StatsIcon,
  Quiz as QuizIcon,
  Score as ScoreIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import { useApp } from '../../context/AppContext';
import { QuizModeCard, StatCard } from '../../components/settings/SettingsCards';

const SettingsDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const { 
    darkMode, 
    setDarkMode,
    quizMode,
    setQuizMode,
    wrongAnswers,
    terms
  } = useApp();

  // 학습 통계 계산
  const totalTerms = terms?.length || 0;
  const totalWrongAnswers = wrongAnswers?.length || 0;
  const correctRate = totalTerms > 0 ? ((totalTerms - totalWrongAnswers) / totalTerms * 100).toFixed(1) : 0;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle 
        sx={{
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SettingsIcon sx={{ mr: 1, fontSize: 28 }} />
          <Typography variant="h5">
            설정
          </Typography>
        </Box>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {/* 다크모드 설정만 남김 */}
          <Grid item xs={12}>
            <Paper 
              elevation={1} 
              sx={{ 
                p: 2, 
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: theme.palette.mode === 'dark' 
                  ? theme.palette.grey[800] 
                  : theme.palette.grey[50],
                border: `1px solid ${theme.palette.divider}`
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {darkMode ? 
                  <DarkModeIcon sx={{ mr: 2, color: theme.palette.primary.main, fontSize: 28 }} /> :
                  <LightModeIcon sx={{ mr: 2, color: theme.palette.warning.main, fontSize: 28 }} />
                }
                <Box>
                  <Typography variant="h6">
                    {darkMode ? '다크 모드' : '라이트 모드'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    화면 테마를 변경합니다
                  </Typography>
                </Box>
              </Box>
              <Switch
                checked={darkMode}
                onChange={(e) => setDarkMode(e.target.checked)}
                color="primary"
              />
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsDialog; 